/**
 * Kulisse für die Arbeits- und Generierungsfolien: Code, der im Hintergrund
 * durchläuft.
 *
 * Sehr zurückhaltend gehalten. Auf der Leinwand steht die Zeit oder der
 * Fortschritt im Vordergrund; die Kulisse soll zeigen, dass gearbeitet wird,
 * und darf nicht mit dem konkurrieren, was das Gremium lesen soll.
 *
 * Reine CSS-Animation, kein Canvas und keine Bibliothek: Sie läuft 8 bis 25
 * Minuten am Stück auf einem Laptop, der gleichzeitig einen Beamer versorgt.
 * `prefers-reduced-motion` schaltet sie still.
 */

/** Zeilen ohne Aussage — es geht um Textur, nicht um Inhalt. */
const ZEILEN = [
  "async function erzeugePrototyp(anforderung) {",
  "  const felder = await lese(anforderung.thema);",
  "  if (!felder.length) return leer();",
  "  return render(felder, { format: 'html' });",
  "}",
  "",
  "const antrag = { name, geburtsdatum, kennzeichen };",
  "await validiere(antrag).catch(zeigeFehler);",
  "",
  "export function Terminwahl({ slots }) {",
  "  const frei = slots.filter((s) => !s.belegt);",
  "  return <Liste eintraege={frei} />;",
  "}",
  "",
  "SELECT kennzeichen, termin FROM anmeldungen",
  "  WHERE status = 'offen' ORDER BY termin;",
  "",
  "def lese_formular(bild):",
  "    text = ocr(bild, sprache='deu')",
  "    return felder_aus(text)",
  "",
  "for (const feld of pflichtfelder) {",
  "  if (!eingabe[feld]) fehlt.push(feld);",
  "}",
  "",
  "commit -m 'Prototyp aus Ihrer Anforderung'",
];

export function CodeKulisse({
  /** Wie viele Spalten durchlaufen. Zwei reichen für die Textur. */
  spalten = 2,
}: {
  spalten?: number;
}) {
  return (
    <div className="code-kulisse" aria-hidden="true">
      {Array.from({ length: spalten }, (_, i) => (
        <div key={i} className={`code-spalte code-spalte-${i + 1}`}>
          {/* Zweimal dieselbe Liste: so kann die Animation nahtlos umlaufen,
              ohne dass eine Lücke durch das Bild wandert. */}
          {[0, 1].map((durchlauf) => (
            <div key={durchlauf} className="code-block">
              {ZEILEN.map((z, n) => (
                <div key={n} className="code-zeile">
                  {z || " "}
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
